import { render, staticRenderFns } from "./pendingDialog.vue?vue&type=template&id=38907506"
import script from "./pendingDialog.vue?vue&type=script&lang=ts"
export * from "./pendingDialog.vue?vue&type=script&lang=ts"
import style0 from "./pendingDialog.vue?vue&type=style&index=0&id=38907506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports